import React, { useState, useEffect } from 'react';
import { Save } from 'lucide-react';
import ImageUpload from '../../components/admin/ImageUpload';
import { resolveImg } from '../../lib/img';

const SettingsManager = () => {
  const [bookCoverUrl, setBookCoverUrl] = useState('');
  const [currentBookCover, setCurrentBookCover] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchBookCover();
  }, []);

  const fetchBookCover = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/book-cover`);
      const data = await response.json();
      if (data.success && data.book_cover_url) {
        setCurrentBookCover(data.book_cover_url);
        setBookCoverUrl(data.book_cover_url);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleUpdateBookCover = async (e) => {
    e.preventDefault();
    if (!bookCoverUrl) {
      setMessage('Please upload an image or paste a URL first.');
      return;
    }
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/book-cover/update`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ book_cover_url: bookCoverUrl })
      });

      const data = await response.json();
      if (data.success) {
        setMessage('Book cover updated successfully! Refresh website to see changes.');
        setCurrentBookCover(bookCoverUrl);
      } else {
        setMessage('Failed to update book cover');
      }
    } catch (error) {
      setMessage('Failed to update book cover');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: '700', marginBottom: '24px' }}>
        Website Settings
      </h1>

      {/* Book Cover Section */}
      <div style={{ backgroundColor: '#FFFFFF', padding: '32px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)', marginBottom: '24px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '24px' }}>Book Cover Image</h2>

        {currentBookCover && (
          <div style={{ marginBottom: '24px' }}>
            <p style={{ fontSize: '0.9rem', fontWeight: '600', marginBottom: '12px', color: '#666666' }}>Current Book Cover:</p>
            <div style={{ maxWidth: '200px', padding: '16px', backgroundColor: '#F5F5F5', borderRadius: '8px' }}>
              <img src={resolveImg(currentBookCover)} alt="Book Cover" style={{ width: '100%', borderRadius: '4px' }} />
            </div>
          </div>
        )}

        {message && (
          <div style={{
            padding: '16px',
            marginBottom: '24px',
            backgroundColor: message.includes('success') ? '#e6f7e6' : '#ffe6e6',
            border: `1px solid ${message.includes('success') ? '#00cc00' : '#ff0000'}`,
            borderRadius: '4px',
            color: message.includes('success') ? '#006600' : '#cc0000'
          }}>
            {message}
          </div>
        )}

        <form onSubmit={handleUpdateBookCover}>
          <ImageUpload
            label="New Book Cover"
            value={bookCoverUrl}
            onChange={(url) => setBookCoverUrl(url)}
            testid="book-cover"
          />
          <p style={{ fontSize: '0.85rem', color: '#666666', margin: '12px 0 24px' }}>
            Upload an image file directly, or paste a direct image URL. Click Save to apply it across the website.
          </p>
          <button
            type="submit"
            disabled={loading}
            data-testid="save-book-cover-button"
            className="btn-primary"
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <Save size={18} />
            {loading ? 'Saving...' : 'Save Book Cover'}
          </button>
        </form>
      </div>

      {/* Email Settings Section */}
      <div style={{ backgroundColor: '#FFFFFF', padding: '32px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px' }}>Email Routing</h2>
        <div style={{ padding: '20px', backgroundColor: '#F5F5F5', borderRadius: '8px' }}>
          <p style={{ fontSize: '1rem', marginBottom: '12px', fontWeight: '600', color: '#000000' }}>Current Email Configuration:</p>
          <ul style={{ fontSize: '0.95rem', color: '#333333', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li>Contact Form → contact@thegoldilockszone.com.au</li>
            <li>Event Registration → events@thegoldilockszone.com.au</li>
            <li>Newsletter Signup → info@thegoldilockszone.com.au</li>
            <li>Bulk Enquiries → info@thegoldilockszone.com.au</li>
          </ul>
          <p style={{ fontSize: '0.85rem', color: '#666666', marginTop: '16px', fontStyle: 'italic' }}>
            All group emails forward to both Craig and Nadir's mailboxes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SettingsManager;
